import styled, { css } from 'styled-components';

export const SelectedPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 8px;
`;

export const SelectedPanelTitle = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.neutral.lowDark};
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
  `}
`;

export const SelectedPanelTitleIcon = styled.img`
  width: 40px;
  height: 40px;
  display: block;
`;

export const SelectedPanelDescription = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    color: ${theme.v2.colors.neutral.lowDark};
    margin-top: 8px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const ProvisionedText = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    color: ${theme.v2.colors.neutral.lowDark};
    margin-top: 16px;
    display: block;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const SelectWrapper = styled.div`
  width: 100%;

  div > {
    width: 100%;
  }
`;
